module.exports = __webpack_public_path__ + "h5/img/newstit.936673d9.png";